import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { tap } from 'rxjs';
import { InactivityDialogComponent } from './inactivity-dialog.component';
import { SessionExpiredDialogComponent } from './session-expired-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private readonly idle = inject(Idle);
  private readonly destroyRef = inject(DestroyRef);

  private readonly dialog = inject(MatDialog);

  /**
   * @param idleTime in minutes
   * @param timeoutTime in minutes
   */
  setup(idleTime: number, timeoutTime: number) {
    this.idle.setIdle(idleTime * 60);
    this.idle.setTimeout(timeoutTime * 60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    let inactivityDialog: MatDialogRef<unknown>;

    this.idle.onIdleStart
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        inactivityDialog = this.dialog.open(InactivityDialogComponent);
      });

    this.idle.onIdleEnd
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        inactivityDialog?.close();
      });
  }

  watch() {
    this.idle.watch();

    return this.idle.onTimeout.pipe(
      tap(() => {
        this.stop();
        this.dialog.closeAll();
        this.dialog.open(SessionExpiredDialogComponent);
      }),
    );
  }

  stop() {
    this.idle.stop();
  }

  readonly idleTimeout = toSignal(this.idle.onTimeoutWarning);
}
